import React from "react"
import ModuleTitle from "../../../atoms/SchedulePages/ModuleTitle"
import "./TravelingCanada.scss"

const TravelingCanada = ({content}) => {
  return (
    <>
      <ModuleTitle title={content.title} />
      <div className="traveling-canada">
        <div className="discount">{content.subtitle}</div>
        <div className="discount-info">
          {content.text}
        </div>
      </div>
    </>
  )
}


export default TravelingCanada